import {useEffect, useState} from 'react';

const ERROR_VERDICT_MS = 1500;

function useCaptureErrorRevealed(isError: boolean) {
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    setIsRevealed(false);
    if (!isError) return;
    const timeout = setTimeout(() => setIsRevealed(true), ERROR_VERDICT_MS);
    return () => clearTimeout(timeout);
  }, [isError]);

  return isRevealed;
}

export {ERROR_VERDICT_MS, useCaptureErrorRevealed};
